export const detectCountryByGeoLocation = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      return fetch(`https://www.cloudflare.com/cdn-cgi/trace`, {
        method: 'GET',
      })
        .then((response) => response.text())
        .then((result) => {
          console.log('geoLocation result', result);

          let loc = '';
          try {
            loc = result.split('\n').reduce((acc: string, r: string) => {
              const [ key, value ] = r.split('=');
              if (key === 'loc') {
                acc = value;
              }
              return acc;
            }, 'cz');
          } catch {
            loc = 'cz';
          }

          if (loc) {
            resolve(loc.toLowerCase());
          } else {
            resolve('cz');
          }
        })
        .catch((err) => {
          console.log('geoLocation error', err);
          reject(`${err}`);
        });
    } catch (error) {
      console.log('geoLocation error', error);
      reject(null);
    }
  });
};


// WEBPACK FOOTER //
// ./src/helpers/country/detectCountryByGeoLocation.tsx